import { guideTips } from "@/mocks/chiGuaData";

const iconBg = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-foreground-950",
  "bg-secondary-500 text-background-50",
  "bg-primary-100 text-primary-700",
  "bg-secondary-100 text-secondary-800",
  "bg-accent-100 text-accent-800",
];

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-compass-3-fill" aria-hidden="true"></i> 冲浪指南
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
              高效吃瓜的小贴士
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              学会这几招，热门事件、新鲜事一个都不错过，还能刷得轻松又理性。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {guideTips.map((tip, i) => (
            <div
              key={tip.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg text-lg ${iconBg[i % iconBg.length]}`}
              >
                <i className={tip.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}